import $wxsdk from '@/libs/sdk-h5-weixin';
import {getRootUrl, headers} from '@/utils/util';
import {getUserInfo, getWxLoginUrl, wxLogin} from '@/api/api';
import {setLocal} from "@/utils/cookie";

// 加载微信公众号JSSDK
async function load() {
  $wxsdk.init();
}

// 微信公众号登陆
async function login(code = '', state = '') {
  // 情况一：没有 code 时，去获取 code
  if (!code) {
    const loginUrl = await getLoginUrl();
    if (loginUrl) {
      localStorage.setItem('returnUrl', location.href);
      window.location = loginUrl;
    }
    // 情况二：有 code 时，使用 code 去自动登录
  } else {
    // 解密 code 发起登陆
    const loginResult = await wechatLogin(code);
    if (loginResult.code === 0) {
      setLocal('asses_token', loginResult.data.token);
      return loginResult;
    }
  }
  return false;
}

function wechatLogin(code) {
  return wxLogin({code}).then(res => {
    return res;
  });
}

// 获取公众号登陆地址
function getLoginUrl(event = 'login') {
  const page = getRootUrl() + 'login' /*+ '?event=' + event*/; // event 目的，区分是 login 还是 bind
  return getWxLoginUrl({redirectUri: page}).then(({code, data}) => {
    if (code !== 0) {
      return undefined;
    }
    return data;
  })
}

// 设置 openid 到本地存储，目前只有 pay 支付时会使用
function setOpenid(openid) {
  localStorage.setItem('openid', openid);
}

// 获得 openid
async function getOpenid(force = false) {
  let openid = localStorage.getItem('openid');
  // if (!openid && force) {
    const info = await getInfo();
    if (info && info.kzOpenid) {
      openid = info.kzOpenid;
      setOpenid(openid);
    }
  // }
  return openid;
}

// 获得社交信息
async function getInfo() {
  const res = await getUserInfo(headers());
  console.log('userInfoRes:', res)
  if (!res || res.code !== 0) {
    return undefined;
  }
  return res.data;
}

export default {
  load,
  login,
  // bind,
  // unbind,
  getInfo,
  getOpenid,
  jsWxSdk: $wxsdk,
};
